import { render } from "./EvalOneToMany.vue?vue&type=template&id=1eb96cc6&scoped=true"
import script from "./EvalOneToMany.vue?vue&type=script&lang=js"
export * from "./EvalOneToMany.vue?vue&type=script&lang=js"

import "./EvalOneToMany.vue?vue&type=style&index=0&id=1eb96cc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb96cc6"]])

export default __exports__